const songs = [
  {
    title: "As It Was",
    artist: "Harry Sytles",
    image: "/img/harry.png",
    src: "/music/asitwas.mp3",
  },
  {
    title: "Sasto Mutu",
    artist: "Sajjan Raj Vaidya",
    image: "/img/sajjan.png",
    src: "/music/sastomutu.mp3",
  },
  {
    title: "I'm Addicted To Your Touch",
    artist: "Sacar",
    image: "/img/sacar.jpg",
    src: "/music/addicted.mp3",
  },
  {
    title: "See You Again",
    artist: "Wiz Khalifa",
    image: "/img/wiz.png",
    src: "/music/seeyouagain.mp3",
  },
  {
    title: "Raavana",
    artist: "Dong",
    image: "/img/dong.jpg",
    src: "/music/raavana.mp3",
  },
];

export default songs;
